module.exports = __webpack_public_path__ + "static/eric-wilson-400w-103018-5261211fd6a49df2e26c6c0bac6621a3.jpg";